import { render } from "./ChangeTheme.vue?vue&type=template&id=026c1a62&scoped=true"
import script from "./ChangeTheme.vue?vue&type=script&lang=js"
export * from "./ChangeTheme.vue?vue&type=script&lang=js"

import "./ChangeTheme.vue?vue&type=style&index=0&id=026c1a62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-026c1a62"]])

export default __exports__